import { spaceMemberGQLFields, } from './spaceMember.fields.js';
export function spaceMembersGQLFields(fields) {
    return `
      members(limit: ${fields.variables.limit || 1}) {
        edges {
          cursor
          node {
            ${spaceMemberGQLFields(fields.fields)}
          }
        }
        nodes {
          ${spaceMemberGQLFields(fields.fields)}
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    `;
}
